import { CertificatePreviewData } from "./certificatePlaceholders";

export const CERTIFICATE_SAMPLE_DATA: CertificatePreviewData = {
  clinicName: "VISO DENTAL CLINIC",
  clinicAddress: "No. 24, Flower Road, Colombo 07",
  clinicPhone: "011 234 5678",
  clinicWhatsapp: "077 123 4567",
  clinicWebsite: "www.visodental.lk",
  clinicEmail: "hello@visodental.lk",
  certificateNumber: "DC-2026-000001",
  certificateDate: "19-06-2026",
  patientName: "Navodya",
  patientId: "P-10482",
  patientAge: "24",
  patientGender: "Female",
  treatmentType: "Orthodontic Treatment",
  treatmentDescription: "orthodontic treatment",
  treatmentDate: "19-06-2026",
  reasonForLeave: "Ongoing orthodontic appliance adjustment and recovery",
  leaveStartDate: "19-06-2026",
  leaveEndDate: "30-06-2026",
  leaveDays: "11",
  recommendationText:
    "Rest and avoid strenuous activity during the recommended leave period.",
  doctorName: "Dr. Mayura Gamalath",
  doctorQualifications: "BDS (Colombo), MD Orthodontics",
  doctorDesignation: "Consultant Orthodontist",
  slmcNumber: "SLMC 12345",
};

export function mergeClinicPreviewData(
  sample: CertificatePreviewData,
  clinic?: {
    clinicName?: string;
    address?: string;
    tpNo?: string;
    printImages?: string;
    email?: string;
    website?: string;
    phoneTwo?: string;
  }
): CertificatePreviewData {
  const looksLikePlaceholder = (value?: string) => {
    const v = String(value ?? "").trim();
    return !v || v === "clinicName" || v === "12454" || v === "0771234567";
  };

  const hasLoggedInClinic = Boolean(
    clinic &&
      (!looksLikePlaceholder(clinic.clinicName) ||
        !looksLikePlaceholder(clinic.address) ||
        !looksLikePlaceholder(clinic.tpNo))
  );

  const realOrEmpty = (value: string | undefined, fallback: string) =>
    looksLikePlaceholder(value) ? (hasLoggedInClinic ? "" : fallback) : String(value).trim();

  const clinicName = looksLikePlaceholder(clinic?.clinicName)
    ? hasLoggedInClinic
      ? ""
      : sample.clinicName
    : String(clinic?.clinicName).toUpperCase();

  return {
    ...sample,
    clinicName,
    clinicAddress: realOrEmpty(clinic?.address, sample.clinicAddress),
    clinicPhone: realOrEmpty(clinic?.tpNo, sample.clinicPhone),
    clinicWhatsapp: realOrEmpty(clinic?.phoneTwo || clinic?.tpNo, sample.clinicWhatsapp),
    clinicEmail: realOrEmpty(clinic?.email, hasLoggedInClinic ? "" : sample.clinicEmail),
    clinicWebsite: realOrEmpty(clinic?.website, hasLoggedInClinic ? "" : sample.clinicWebsite),
  };
}
